import * as React from "react";

import { TrackClick } from "../../../hoc";
import "./CustomColorSelector.css";

export interface CustomColorSelectorProps {
  customColorsChecked: boolean;
  toggleCheckbox: () => void;
  children: React.ReactChild | React.ReactChild[];
}

const CustomColorSelector = (props: CustomColorSelectorProps) => (
  <div className="custom-color">
    <TrackClick
      category="wizard"
      action={
        props.customColorsChecked ? (
          "Unclicked custom color"
        ) : (
          "Clicked custom color"
        )
      }
      onClick={props.toggleCheckbox}
      render={handleClick => (
        <input
          className="custom-color__checkbox"
          id="custom-color-checkbox"
          type="checkbox"
          checked={props.customColorsChecked}
          onClick={handleClick}
        />
      )}
    />
    <label
      className="custom-color__checkbox-label"
      htmlFor="custom-color-checkbox"
    >
      <span className="hidden-xs">Tôi muốn mã màu riêng:</span>
      <span className="visible-xs">Mã màu:</span>
    </label>
    {props.customColorsChecked && (
      <ul className="custom-color__extra-colors">{props.children}</ul>
    )}
  </div>
);

export default CustomColorSelector;



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/components/CustomColorSelector.tsx